import React from 'react';
import BrandLockup from './BrandLockup';
import './AppHeader.css';

export default function AppHeader({
  onBrandClick,
  rightSlot = null,
  fixed = false,
  title = 'GLOBAL MOBILITY',
  subtitle = 'SPAIN REGULARIZATION 2026',
}) {
  const brand = (
    <BrandLockup
      containerClassName="gm-app-header-brand"
      logoClassName="gm-app-header-logo"
      imageClassName="gm-app-header-logo-image"
      textWrapperClassName="gm-app-header-copy"
      titleClassName="gm-app-header-title"
      subtitleClassName="gm-app-header-subtitle"
      title={title}
      subtitle={subtitle}
    />
  );

  return (
    <header className={`gm-app-header${fixed ? ' gm-app-header--fixed' : ''}`}>
      <div className="gm-app-header-inner">
        {onBrandClick ? (
          <button type="button" className="gm-app-header-brand-btn" onClick={onBrandClick}>
            {brand}
          </button>
        ) : (
          brand
        )}
        {rightSlot ? <div className="gm-app-header-right">{rightSlot}</div> : null}
      </div>
    </header>
  );
}
